'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _contactLink = require('common/components/contact-link');

var _contactLink2 = _interopRequireDefault(_contactLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('div', {
    className: 'm-docusign-switch__case-study-border'
});

var _ref2 = _jsx(_contactLink2['default'], {});

module.exports = function (_React$Component) {
    _inherits(DocusignSwitch, _React$Component);

    function DocusignSwitch() {
        _classCallCheck(this, DocusignSwitch);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(DocusignSwitch).apply(this, arguments));
    }

    _createClass(DocusignSwitch, [{
        key: 'render',
        value: function render() {
            var words = ['better', 'easier', 'friendly'];
            return _jsx('div', {
                className: 'm-docusign-switch'
            }, void 0, _jsx('header', {}, void 0, _jsx('h1', {}, void 0, 'Say Hello to ', _jsx(WordSlider, {
                words: words
            }), ' eSignatures'), _jsx('h2', {}, void 0, 'DocuSign', '®', ' users, welcome to the future of eSigning'), _jsx('a', {
                href: '/info/pricing'
            }, void 0, _jsx('button', {
                className: 'bg-cerulean c-white hc-white hbg-velvet-evening'
            }, void 0, 'SWITCH NOW'))), _jsx('section', {
                className: 'm-docusign-switch__why-switch'
            }, void 0, _jsx('h2', {}, void 0, 'WHY SWITCH?'), _jsx('section', {
                className: 'm-docusign-switch__better-signing-experience'
            }, void 0, _jsx('div', {
                className: 'center-image-wrapper macbook'
            }, void 0, _jsx('img', {
                src: require('./assets/macbook_@2x.png'),
                'aria-hidden': true
            })), _jsx('div', {
                className: 'm-docusign-switch__copy why-switch-copy'
            }, void 0, _jsx('h3', {}, void 0, 'Better signing experience for you and your customers.'), _jsx('p', {}, void 0, 'We\'ve created the ', _jsx('a', {
                target: '_blank',
                href: 'http://blog.hellosign.com/new-signer-experience/'
            }, void 0, 'most intuitive interface in the industry'), ' without compromising on functionality. Our stream-lined, user-friendly design combined with powerful features won’t disappoint you, your team, or your customers when it comes to signing important docs online. We don’t believe in unnecessary clutter.'))), _jsx('section', {
                className: 'm-docusign__easier-to-sign-anywhere'
            }, void 0, _jsx('div', {
                className: 'center-image-wrapper signer-experience-image-wrapper'
            }, void 0, _jsx('img', {
                src: require('./assets/signer_experience_@2x.png'),
                'aria-hidden': true
            })), _jsx('div', {
                className: 'm-docusign-switch__copy sign-anywhere-copy'
            }, void 0, _jsx('h3', {}, void 0, 'Easier to sign anywhere, at any time, on any device.'), _jsx('p', {}, void 0, 'Sometimes signing a document needs to happen at a moment\'s notice. Our responsive design allows you to request a signature or sign on-the-go. And with a ', _jsx('a', {
                target: '_blank',
                href: ' https://www.hellosign.com/info/tour'
            }, void 0, 'growing list of industry-first features'), ' like our "Insert Everywhere" button and data validation, we’re confident you’ll love the experience.'))), _jsx('section', {
                className: 'm-docusign-switch__features'
            }, void 0, _jsx('div', {
                className: 'm-docusign-switch__features-row'
            }, void 0, _jsx('section', {}, void 0, _jsx('div', {
                className: 'm-docusign-switch__copy'
            }, void 0, _jsx('img', {
                src: require('./assets/feature_icons/support_icon_@2x.svg'),
                'aria-hidden': true,
                className: 'm-docusign-switch-support_icon'
            }), _jsx('h3', {}, void 0, 'Best-in-class developer and user support.'), _jsx('p', {}, void 0, 'We understand that eSignatures power a critical piece of your business, so we take support very seriously. Our expert support team is devoted to helping you get the most value out of eSignatures. We also have a specialized API support team which means the person that helped integrate eSignatures into your product will be the same person you can come to for questions.'))), _jsx('section', {}, void 0, _jsx('div', {
                className: 'm-docusign-switch__copy integrate-copy'
            }, void 0, _jsx('img', {
                src: require('./assets/feature_icons/integrate_icon.svg'),
                'aria-hidden': true,
                className: 'm-docusign-switch-integrate_icon'
            }), _jsx('h3', {}, void 0, 'Integrate eSignatures with anything, faster.'), _jsx('p', {}, void 0, 'Want to integrate eSignatures into your own apps or site?', _jsx('a', {
                href: 'https://www.hellosign.com/api',
                target: '_blank'
            }, void 0, ' Our API '), 'makes that a cinch too. Our eSignature API is designed with ', _jsx('a', {
                target: '_blank',
                href: 'http://blog.hellosign.com/the-rise-of-developer-experience/'
            }, void 0, 'developer experience top of mind'), '. We offer a variety of ways to integrate a signing flow directly into your site and the highest level of customization available in the industry with our ', _jsx('a', {
                target: '_blank',
                href: 'https://www.hellosign.com/api/white-labeling'
            }, void 0, 'white labeling functionality'), '. We believe in making eSignatures feel like a seemless part of your product.')))), _jsx('div', {
                className: 'm-docusign-switch__features-row'
            }, void 0, _jsx('section', {
                className: 'copy-shift'
            }, void 0, _jsx('div', {
                className: 'm-docusign-switch__copy'
            }, void 0, _jsx('img', {
                src: require('./assets/feature_icons/pricing_icon_@2x.png'),
                'aria-hidden': true,
                className: 'm-docusign-switch-pricing_icon'
            }), _jsx('h3', {}, void 0, 'Transparent pricing. No hidden fees. No hassle.'), _jsx('p', {}, void 0, 'Unlike DocuSign, we offer transparent pricing from the get go. That means no hidden fees and no unexpected price hikes. DocuSign users are often surprised by unexplained fees or charges. You\'ll be happy to hear we’ll never surprise you with pricing — we’re just not really into that kind of thing.'))), _jsx('section', {}, void 0, _jsx('div', {
                className: 'm-docusign-switch__copy modern-tools-copy'
            }, void 0, _jsx('img', {
                src: require('./assets/feature_icons/modern_tools_icon.svg'),
                'aria-hidden': true,
                className: 'm-docusign-switch-pricing_icon'
            }), _jsx('h3', {}, void 0, 'Sync eSignatures with your favorite modern tools.'), _jsx('p', {}, void 0, 'We integrate with all your favorite apps. Easily pull files from your cloud storage account into HelloSign, or send a signature request directly from Dropbox, OneDrive, or Box. Sign a document right from Gmail with one click — we work seamlessly with Google Apps. Keep up to date with actionable eSignature updates in Slack and Hubspot CRM. You can even access all of your Evernote documents in HelloSign.')))), _jsx('section', {
                className: 'pricing-button'
            }, void 0, _jsx('a', {
                href: '/info/pricing'
            }, void 0, _jsx('button', {
                className: 'bg-cerulean c-white hc-white hbg-velvet-evening'
            }, void 0, 'SEE PRICING'))))), _jsx('section', {
                className: 'm-docusign-switch__api-container'
            }, void 0, _jsx('h2', {}, void 0, 'See how HelloSign\'s eSignature API compares to Docusign API'), _jsx('div', {
                className: 'm-docusign-switch__api-icons-container'
            }, void 0, _jsx('div', {
                className: 'm-docusign-switch__api-container__icon-container'
            }, void 0, _jsx('img', {
                src: require('./assets/api_icons/api_clock_icon.svg'),
                'aria-hidden': true
            }), _jsx('p', {}, void 0, 'Accept eSignatures in minutes')), _jsx('div', {
                className: 'm-docusign-switch__api-container__icon-container'
            }, void 0, _jsx('img', {
                src: require('./assets/api_icons/api_free_icon.svg'),
                'aria-hidden': true
            }), _jsx('p', {}, void 0, 'Free during development')), _jsx('div', {
                className: 'm-docusign-switch__api-container__icon-container'
            }, void 0, _jsx('img', {
                src: require('./assets/api_icons/api_docs_icon.svg'),
                className: 'docs-icon',
                'aria-hidden': true
            }), _jsx('p', {}, void 0, 'Clean Documentation')), _jsx('div', {
                className: 'm-docusign-switch__api-container__icon-container'
            }, void 0, _jsx('img', {
                src: require('./assets/api_icons/api_dashboard_icon.svg'),
                className: 'docs-icon',
                'aria-hidden': true
            }), _jsx('p', {}, void 0, 'Industry-first API Dashboard'))), _jsx('div', {}, void 0, _jsx('a', {
                href: '/api/hellosign-vs-docusign'
            }, void 0, _jsx('button', {
                className: 'bg-goldenrod hc-goldenrod border-1-goldenrod hbg-white c-white'
            }, void 0, 'LEARN MORE')))), _jsx('section', {
                className: 'm-docusign-switch__happy-customers'
            }, void 0, _jsx('h2', {}, void 0, 'HAPPY HELLOSIGN CUSTOMERS'), _jsx('div', {
                className: 'm-docusign-switch__logos-container'
            }, void 0, _jsx('div', {
                className: 'm-docusign-switch__happy-customer__intuit'
            }, void 0, _jsx('img', {
                src: require('./assets/logos/intuit_logo_@2x.png'),
                'aria-hidden': true
            })), _jsx('div', {
                className: 'm-docusign-switch__happy-customer__instacart'
            }, void 0, _jsx('img', {
                src: require('./assets/logos/instacart_logo_@2x.png'),
                'aria-hidden': true
            })), _jsx('div', {
                className: 'm-docusign-switch__happy-customer__lyft'
            }, void 0, _jsx('img', {
                src: require('./assets/logos/lyft_logo_@2x.png'),
                'aria-hidden': true
            })), _jsx('div', {
                className: 'm-docusign-switch__happy-customer__samsung'
            }, void 0, _jsx('img', {
                src: require('./assets/logos/samsung_logo_@2x.png'),
                'aria-hidden': true
            })), _jsx('div', {
                className: 'm-docusign-switch__happy-customer__twitter'
            }, void 0, _jsx('img', {
                src: require('./assets/logos/twitter_logo_@2x.png'),
                'aria-hidden': true
            })))), _jsx('section', {
                className: 'm-docusign-switch__case-studies'
            }, void 0, _jsx('div', {
                className: 'case-study-header'
            }, void 0, _jsx('h2', {}, void 0, 'CASE STUDIES')), _jsx('div', {
                className: 'm-docusign-switch__case-studies-container'
            }, void 0, _jsx('section', {
                className: 'm-docusign-switch__case-study openlegal'
            }, void 0, _jsx('img', {
                src: require('./assets/logos/openlegal_logo.png'),
                'aria-hidden': true
            }), _jsx('h4', {}, void 0, 'Law startup Openlegal reduced administrative costs by 30-50% with HelloSign.'), _jsx('p', {}, void 0, '"[HelloSign] syncs to Google Drive, Dropbox, etc. which means we can often access documents without having to open up HelloSign."'), _jsx('p', {}, void 0, 'Ric Gruber, Partner, ', _jsx('strong', {}, void 0, 'Openlegal')), _jsx('div', {
                className: 'case-study-learn-more'
            }, void 0, _jsx('a', {
                href: 'http://info.hellosign.com/openlegal-case-study.html',
                target: '_blank'
            }, void 0, 'LEARN MORE'))), _ref, _jsx('section', {
                className: 'm-docusign-switch__case-study trxade'
            }, void 0, _jsx('img', {
                src: require('./assets/logos/trxade_logo.png'),
                'aria-hidden': true
            }), _jsx('h4', {}, void 0, 'When their eSignature provider hiked their rates more than 400%, pharmacy platform Trxade switched to HelloSign\'s API in days.'), _jsx('p', {}, void 0, '"My biggest liking about HelloSign was just the ease. We used some of your advanced functionality right off the bat and it was really quick to implement and that was really nice."'), _jsx('p', {}, void 0, 'Jeff Davis, CTO, ', _jsx('strong', {}, void 0, 'Trxade')), _jsx('div', {
                className: 'case-study-learn-more'
            }, void 0, _jsx('a', {
                href: 'http://info.hellosign.com/trxade-case-study.html',
                target: '_blank'
            }, void 0, 'LEARN MORE'))))), _jsx('footer', {}, void 0, _jsx('div', {
                className: 'm-docusign-switch__footer-left'
            }, void 0, _jsx('a', {
                href: '/info/aboutUs',
                target: '_blank'
            }, void 0, 'About HelloSign'), _ref2), _jsx('div', {
                className: 'm-docusign-switch__footer-right'
            }, void 0, _jsx('span', {
                className: 'hs-copyright'
            }, void 0, 'HelloSign ', '©', ' 2016'))));
        }
    }]);

    return DocusignSwitch;
}(_react2['default'].Component);

var WordSlider = function (_React$Component2) {
    _inherits(WordSlider, _React$Component2);

    function WordSlider(props) {
        _classCallCheck(this, WordSlider);

        var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(WordSlider).call(this, props));

        _this2.timeouts = [];
        _this2.state = {
            currentWordIndex: 0,
            animation: 'animate-in'
        };
        return _this2;
    }

    _createClass(WordSlider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initiateAnimateOut();
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            this.timeouts.forEach(clearTimeout);
            this.timeouts = [];
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'initiateAnimateOut',
        value: function initiateAnimateOut() {
            var _this3 = this;

            this.timeouts.push(setTimeout(function () {
                return _this3.animateOut();
            }, 3000));
        }
    }, {
        key: 'animateOut',
        value: function animateOut() {
            var _this4 = this;

            this.setState({ animation: 'animate-out' });
            this.timeouts.push(setTimeout(function () {
                return _this4.incrementIndex();
            }, 320));
        }
    }, {
        key: 'incrementIndex',
        value: function incrementIndex() {
            var currentWordIndex = this.state.currentWordIndex;
            if (currentWordIndex < this.props.words.length - 1) currentWordIndex++;else currentWordIndex = 0;
            this.initiateAnimateOut();
            this.setState({
                currentWordIndex: currentWordIndex,
                animation: 'animate-in'
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var currentWord = this.props.words[this.state.currentWordIndex];
            var classes = 'slider-text ' + this.state.animation;
            return _jsx('span', {
                className: classes
            }, void 0, currentWord);
        }
    }]);

    return WordSlider;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/index.jsx
 ** module id = 938
 ** module chunks = 0
 **/